// extracted by mini-css-extract-plugin
export var column = "_sy-0";
export var divider = "_sy-2";
export var timePicker = "_sy-1";